export default "__VITE_ASSET__DboWUGGT__"